import browser from 'browser-detect';

export const detectarNavegador = () => {
    const detNavegador = browser();    
    return (detNavegador.name + ": " + detNavegador.version).concat(" (móvil: " + detNavegador.mobile + ") ").concat(" SO: " + detNavegador.os);
}